/* SAMPLE COLLECTORS */
// get SECTOR
export const GET_SECTOR_LIST = "GET_SECTOR_LIST";
export const GET_SECTOR_LIST_SUCCESS ="GET_SECTOR_LIST_SUCCESS";
export const GET_SECTOR_LIST_FAIL = "GET_SECTOR_LIST_FAIL";
// Add SECTOR
export const ADD_NEW_SECTOR = "ADD_NEW_SECTOR";
export const ADD_NEW_SECTOR_SUCCESS = "ADD_NEW_SECTOR_SUCCESS";
export const ADD_NEW_SECTOR_FAIL = "ADD_NEW_SECTOR_FAIL";
//Update SECTOR
export const UPDATE_SECTOR = "UPDATE_SECTOR";
export const UPDATE_SECTOR_SUCCESS = "UPDATE_SECTOR_SUCCESS";
export const UPDATE_SECTOR_FAIL = "UPDATE_SECTOR_FAIL";


